import {BASE_URL} from "../../config/network";
import {resolveWhiteLabelSubsidiaryId} from "../../config/subsidiaryId";

const cancelDocumentCaptureSessionAPI = async ({subsidiaryId, resultToken}) => {
    const requestSubsidiaryId = resolveWhiteLabelSubsidiaryId(subsidiaryId);
    const URL = `${BASE_URL}/${requestSubsidiaryId}/public/document-capture/session/${encodeURIComponent(resultToken)}`;
    const METHOD = "DELETE";
    const HEADERS = {
        Accept: "application/json",
    };

    const response = await fetch(URL, {
        method: METHOD,
        headers: HEADERS,
    });

    if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
    }

    if (response.status === 204) {
        return {};
    }

    try {
        return await response.json();
    } catch (_error) {
        return {};
    }
};

export {cancelDocumentCaptureSessionAPI};
